import {
  minLength,
  notConsecutiveCharacters,
  doesNotContain,
} from '@seek/validators-js';

import type { FieldState } from './NewPassword';

export const minimumLength = 8;
export enum Tones {
  Neutral = 'neutral',
  Critical = 'critical',
  Positive = 'positive',
}

export type Tone = Tones.Neutral | Tones.Critical | Tones.Positive;

export const fieldState = (tone: Tone, message: string = ''): FieldState => ({
  tone,
  message,
});

export const getTone = (password: string): Tones => {
  let strength = 0;
  // Contains uppercase characters
  if (password.match(/[A-Z]/)) {
    strength++;
  }
  // contains lowercase characters
  if (password.match(/[a-z]/)) {
    strength++;
  }
  // Contains numeric characters
  if (password.match(/[0-9]/)) {
    strength++;
  }
  // A symbol of some kind
  if (password.match(/[^a-zA-Z0-9]/)) {
    strength++;
  }

  if (strength >= 3) {
    return Tones.Positive;
  }
  return Tones.Neutral;
};

export const findErrors = (
  value: string,
  minLengthMessage: string,
  forbiddenString: string,
  t: any,
): undefined | string => {
  const minLengthValid = minLength.test({
    value,
    validatorProps: { min: minimumLength },
    formValues: {},
  });
  if (!minLengthValid) {
    return minLengthMessage;
  }
  const notConsecutiveCharactersValid = notConsecutiveCharacters.test({
    value,
    validatorProps: { consecutive: 2 },
    formValues: {},
  });
  if (!notConsecutiveCharactersValid) {
    return t('Cannot contain identical characters in a sequence', {
      consecutive: 3,
    });
  }
  const doesNotContainValid = doesNotContain.test({
    value,
    validatorProps: { forbiddenStrings: [forbiddenString] },
    formValues: {},
  });
  if (!doesNotContainValid && forbiddenString) {
    return t('Cannot contain your name or part of your email');
  }
};
